import * as React from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'

import { PageTitleWithTotal } from '~/components/page-title-with-total'
import Icon from '~/truck/icon'
import theme from '~/truck/theme'

const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  padding: ${theme.spacing.comfortable}px;
  width: 100%;

  > svg:first-child {
    margin-right: ${theme.spacing.cozy}px;
  }
`

function Header(props) {
  const { title, numOfHints } = props

  const router = useRouter()

  return (
    <>
      <TitleContainer>
        <Icon type="arrow-left" color="black" onClick={() => router.back()} />
        <PageTitleWithTotal title={title} total={numOfHints} />
      </TitleContainer>
    </>
  )
}

export default Header
